import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.reportVerification || initialState;

export const selectLoading = createSelector(
    [selectDomain],
    (state) => state.loading
);
export const selectError = createSelector(
    [selectDomain],
    (state) => state.error
);
export const selectVerificationData = createSelector(
    [selectDomain],
    (state) => state.verificationData
);